import script from "./ALinhaDivisora.vue?vue&type=script&lang=ts&setup=true"
export * from "./ALinhaDivisora.vue?vue&type=script&lang=ts&setup=true"

import "./ALinhaDivisora.vue?vue&type=style&index=0&id=09afc2e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09afc2e0"]])

export default __exports__